const scrollTop = (selector = ".md-app-scroller", pixels = 0) =>
  Array.from(document.querySelectorAll(selector)).map(
    (item) => (item.scrollTop = pixels)
  );

export default scrollTop;
